// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SRIt","select":"styles_select__pCsIx"};